import { render } from "./BookingList.vue?vue&type=template&id=60a6151a&scoped=true"
import script from "./BookingList.vue?vue&type=script&lang=js"
export * from "./BookingList.vue?vue&type=script&lang=js"

import "./BookingList.vue?vue&type=style&index=0&id=60a6151a&scoped=true&lang=css"

import exportComponent from "E:\\sanket\\rio\\rio_admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60a6151a"]])

export default __exports__